import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';
function* getComplaintsDataResponse({ payload: { offset, limit, search, fromDate, toDate  , agentId} }) {
  try {
    const response = yield call(axiosPrivate, `/cou-dashboard/complaints/tickets?agentId=${agentId ? agentId : '' }&page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search} ` : ''}${fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ''}${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ''}`);
    console.log('response complaint',response.data);
    if (response.status === 200) {

      yield put(actions.getComplaintsDataSuccess(response.data, response.data.total));
    } else {
      yield put(actions.getComplaintsDataFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getComplaintsDataFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_COMPLAINTS_DATA, getComplaintsDataResponse)]);

}
